import { AllCategoriesHooks } from "./hooks/CategoriesHooks";
import SearchBar from "../../components/universal/SearchBar";
import { allCategoriesData, allCategoriesHeaders } from "./Constants";
import CustomTable from "../../components/universal/CustomTable";
import { AiOutlinePlus } from "react-icons/ai";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Navbar from "../../components/universal/Navbar";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css";
import ConfirmToast from "../../components/universal/ConfirmToast";
import CategoryModal from "./AddCategoryModal";  // import modal
import { useState } from "react";
import { useSelector } from "react-redux";
function AllCategories({church}) {
  // search bar component state with handler
  const {
    value,
    onChangeSearchBar,
    fetchAllCategories,
    reloadData,
    setReloadData,
    handleDelete,
    handleEyeClick,
  } = AllCategoriesHooks();

  const navigate = useNavigate();
  const location = useLocation();
      const { userInfo } = useSelector((state) => state.user);

  const hideUI = location.pathname.includes("addfield")|| userInfo?.roleCode==='17dwer8'||location.pathname.includes("addMinistryField")||location.pathname.includes("addChannelField");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  return (
    <>
    <div className="App bg-[#191919] h-fit min-h-screen flex p-4">
     { !hideUI &&<Navbar />}
      <div className={`flex-1 ${!hideUI&&'md:pl-32'} md:pt-0 pt-20`}>
        <div className="flex flex-col gap-4 h-full">
         { !hideUI&&<SearchBar placeholder={"Search"} value={value} onChangeSearchBar={onChangeSearchBar} />}
          <div className="MAIN-CONTENT flex-1 flex flex-col h-full gap-4">
            <div className={`flex w-full ${!hideUI ?'justify-between':'justify-end'} md:items-center md:flex-row flex-col gap-4 md:mb-0 mb-2`}>
            { !hideUI && <p className=" text-white text-3xl font-medium">Categories</p>}
             { !hideUI && <div className="flex gap-4">
  <button
    onClick={() => {
      if (hideUI) {
        // open modal directly
        setSelectedRow(null); // empty row for "new"
        setIsModalOpen(true);
      } else {
        // navigate to add category page
        navigate("/categories/add");
      }
    }}
    className="flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl"
  >
    <AiOutlinePlus /> Add New Category
  </button>
</div>
}
            </div>
            <div  className={`${hideUI && 'relative'}`}>
                          { hideUI &&
                          <div className="flex gap-4 absolute right-0 mt-2">
                          <button
                                  onClick={() => {
                                    setSelectedRow(null); // new video
                                    setIsModalOpen(true);
                                  }}
                                  className="flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl"
                                >
                                  <AiOutlinePlus />  Add New Category
                                </button>
              </div>
              }
              {!isModalOpen &&
              <CustomTable
                searchFor={"Categories"}
                heightDesktop={"h-[72vh]"}
                width={"w-24"}
                // giving extra width to 2nd column
                nthChildWidth={
                  "[&>*:nth-child(2)]:w-40 [&>*:nth-child(2)]:w-40 [&>*:nth-child(3)]:w-32 [&>*:nth-child(3)]:w-32"
                }
                notificationTable={true}
                data={allCategoriesData}
                headers={allCategoriesHeaders}
                customDataFetch={true}
                customDataFetchFunction={fetchAllCategories}
                reloadData={reloadData}
                setReloadData={setReloadData}
                reverseTable={true}
                handleDeleteClick={(row) => {
                  const options = {
                    customUI: ({ onClose }) => {
                      return (
                        <ConfirmToast
                          title="Are you sure?"
                          message="You want to delete this category?"
                          onClose={() => onClose()}
                          onSuccess={() => {
                            handleDelete(row);
                            onClose();
                          }}
                        />
                      );
                    },
                    closeOnEscape: true,
                    closeOnClickOutside: true,
                    keyCodeForClose: [8, 32],
                    overlayClassName: "!bg-gray-500 !bg-opacity-75",
                  };

                  confirmAlert(options);
                }}
                nthChildStyle={"[&>*:nth-child(2)]:h-5 [&>*:nth-child(2)]:overflow-hidden"}
                handleToggleClick={(row, isActive) => {
                                  }}
                handleEyeClick={(row) => {
                                    navigate("/categories/add", {
                    state: {
                      _id: row?._id,
                      options: location?.state?.options,
                    },
                  });
                }}
                handleEditClick={(row) => {
                  if (hideUI) {
                    setSelectedRow(row); // pass row into modal
                    setIsModalOpen(true);
                  } else {
                    navigate("/categories/add", {
                      state: {
                        _id: row?._id,
                        options: location?.state?.options,
                      },
                    });
                  }
                }}
                // handleEditClick={(row) => {
                //   navigate("/categories/add", {
                //     state: {
                //       _id: row?._id,
                //       options: location?.state?.options,
                //     },
                //   });
                // }}
              />
}
            </div>
          </div>
        </div>
      </div>
    </div>
    <CategoryModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        rowData={selectedRow}
        hideUI={hideUI}
        reloadData={reloadData}
        setReloadData={setReloadData}
        church={church}
        // setCategoryInputs={setCategoryInputs}
      />
    </>
  );
}

export default AllCategories;
